import { render, staticRenderFns } from "./UserEdite.vue?vue&type=template&id=b56bd628&scoped=true"
import script from "./UserEdite.vue?vue&type=script&lang=js"
export * from "./UserEdite.vue?vue&type=script&lang=js"
import style0 from "./UserEdite.vue?vue&type=style&index=0&id=b56bd628&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56bd628",
  null
  
)

export default component.exports